<!--越早寄越优惠-->
<template>
    <li>
        <div class="func-item">
            <span class="icon-sf-cost-lower bigger"
                ><span class="icon-path1"></span><span class="icon-path2"></span><span class="icon-path3"></span
            ></span>
            <span class="ui-btn-right"
                ><span class="text">{{ _ll('代表越早寄越优惠') }}</span
                ><span class="ui-ico ui-ico-right"></span
            ></span>
        </div>
    </li>
</template>

<script>
export default {
    name: 'TheEarlierTheCheaper'
}
</script>

<style scoped>
@font-face {
    font-family: 'sf-express';
    src: url('/src/assets/fonts/sf-express.ttf?u2m6c4') format('truetype'), url('/src/assets/fonts/sf-express.woff?u2m6c4') format('woff'),
        url('/src/assets/fonts/sf-express.svg?u2m6c4#sf-express') format('svg');
    font-weight: normal;
    font-style: normal;
}
li {
    border-top: 0;
    border-bottom: #ddd 1px solid;
    list-style: none;
    font-size: 100%;
    font-weight: normal;
}
.func-item {
    min-height: 30px;
    padding-left: 50px;
    position: relative;
    z-index: 0;
    padding: 10px 10px 10px 60px;
    display: block;
}
a {
    cursor: pointer;
    color: #808080;
}
.func-item .ui-ico:first-child {
    position: absolute;
    top: 10px;
    left: 10px;
}
.ui-ico {
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    background-position: 50% 50%;
}
.ui-btn-right {
    padding-right: 30px;
    position: relative;
    z-index: 0;
    display: block;
}
.func-item .text {
    display: block;
    padding: 5px 0;
    color: #333;
}
.ui-ico-right {
    background: url(../../../assets/images/sixpart/ico_arrow_right.png) no-repeat right 50%;
    background-size: auto 20px;
    width: 10px;
}
.ui-ico-right {
    position: absolute;
    top: 0;
    right: 5px;
    display: block;
    width: 20px;
    height: 100%;
}
.icon-sf-cost-lower .icon-path1:before {
    color: rgb(233, 36, 6);
}
.icon-sf-cost-lower .icon-path2:before {
    margin-left: -1em;
    color: rgb(255, 255, 255);
}
.icon-sf-cost-lower .icon-path3:before {
    margin-left: -1em;
    color: rgb(219, 29, 49);
}
.icon-sf-cost-lower {
    font-size: 20px;
    vertical-align: middle;
    position: relative;
    bottom: 4px;
}
.icon-sf-cost-lower.bigger {
    font-size: 30px;
    position: absolute;
    top: 10px;
    left: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/additionalService/the-earlier-the-cheaper.vue